import { gql } from "@apollo/client";

export const REGISTER_USER_ACTION = gql`
  mutation RegisterUserAction($input: RegisterUserActionInput!) {
    registerUserAction(input: $input)
  }
`;
